<div class="horizinns-container property-edit-container">
    <!-- <mat-card class="property-edit-card"> -->
        <div class="property-edit-top-row">
            <div>
                <button mat-flat-button class="metallic-text-btn-blue" (click)="goBack()"><mat-icon matPrefix>arrow_back</mat-icon>Go back</button>
            </div>
            <div class="center">
                <img src="/assets/images/logo_full_900.png" class="main-logo" alt="Horizinns logo"/>
                <img src="/assets/images/logo_single.png" class="second-logo" alt="Horizinns alternate logo"/>
            </div>
            <div>
                <h3>Edit Property</h3>
            </div>
        </div>
    <!-- </mat-card> -->
    @if (property$ | async; as property) {
        <div class="property-field-container">
            <mat-card>
                <mat-card-content>
                    <span class="section-label">Property Display Name</span>
                    <div class="section edit-item-container">
                        <h3> {{ property.displayName ?? property.propertyType | titlecase }} in {{ property.address.city | titlecase }}, {{ property.address.state | uppercase }}</h3>
                        <button matIconButton type="button" matTooltip="Edit Display Name" (click)="editDisplayName(property.displayName || '')"><mat-icon>edit</mat-icon></button>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-content>
                    <span class="section-label">Timezone</span>
                        <div class="section edit-item-container">
                            <div>
                                {{ property.timezone?.displayName ?? 'N/A' }}
                            </div>
                            <div>
                                <button matIconButton type="button" matTooltip="Edit Timezone" (click)="editTimezone(property.timezone?.ianaName ?? '')"><mat-icon>edit</mat-icon></button>
                            </div>
                        </div>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-content>
                    <span class="section-label">
                            Property Address
                            <button matIconButton type="button" matTooltip="Edit Address" (click)="editAddress(property.address)"><mat-icon>edit</mat-icon></button>
                        </span>
                        <div class="section edit-item-container">
                            <div>
                                <div>{{ property.address.street }}</div>
                                <div>{{ property.address.city }}, {{ property.address.state }} {{ property.address.zipCode }}</div>
                            </div>
                        </div>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-content>
                    <span class="section-label">Property Details</span>
                        <div class="section">
                            <div class="edit-item-container">
                                <div>
                                    <div class="icon-with-label">
                                        <span class="material-symbols-outlined" matTooltip="Property Type">house</span> 
                                        <span>{{ property.propertyType | titlecase }}</span>
                                    </div>
                                    
                                    <div class="icon-with-label">
                                        <span class="material-symbols-outlined" matTooltip="Square Footage">square_foot</span>
                                        <span>{{ property.sizeSqft + ' ft²'}}</span>
                                    </div>
            
                                    <div class="icon-with-label">
                                        <span class="material-symbols-outlined" matTooltip="Bedrooms">bed</span>
                                        <span>{{ property.bedrooms + ' bedrooms' || 'N/A' }} {{ property.sleeps ? ' (sleeps ' + property.sleeps + ')' : '' }}</span>
                                    </div>
            
                                    <div class="icon-with-label">
                                        <span class="material-symbols-outlined" matTooltip="Bathrooms">bathtub</span>
                                        <span>{{ property.bathrooms + ' bathrooms' || 'N/A' }}</span>
                                    </div>
                                </div>
                                <button matIconButton type="button" matTooltip="Edit Details" (click)="editPropertyDetails(property)"><mat-icon>edit</mat-icon></button>
                            </div>
                        </div>
                </mat-card-content>
            </mat-card>

            <mat-card class="two-thirds-field">
                <mat-card-content>
                    <span class="section-label">
                            Description
                            <button matIconButton type="button" matTooltip="Edit Description" (click)="editDescription(property.description ?? '')"><mat-icon>edit</mat-icon></button>
                        </span>
                        <div class="section edit-item-container">
                            <div>
                                {{ property.description }}
                            </div>
                        </div>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-content>
                    <span class="section-label">
                            Amenities
                            <button matIconButton type="button" matTooltip="Edit Amenities" (click)="editAmenities(property.amenities)"><mat-icon>edit</mat-icon></button>
                        </span>
                        <div class="section">
                            @for (c of categories; track c) {
                                @if (getAmenitiesForCategory(property, c).length > 0) {
                                    <div>
                                        <h3><span class="material-symbols-outlined">{{ getCategoryIcon(c) }}</span> {{c}}</h3>
                                        <div>
                                            @for (a of getAmenitiesForCategory(property, c); track a.id) {
                                                <mat-chip>{{ a.name }}</mat-chip>
                                            } 
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                </mat-card-content>
            </mat-card>

            <mat-card class="two-thirds-field">
                <mat-card-content>
                    <span class="section-label">
                            Property Images
                            <button matIconButton type="button" matTooltip="Edit Images" (click)="editImages(property.images ?? [])"><mat-icon>edit</mat-icon></button>
                        </span>
                        <div>
                            @if(property.images.length > 0) {
                                <div class="property-images">
                                @for(img of property.images; track img) {
                                    <div class="property-edit-img-container">
                                        <img [src]="img.imageUrl" alt="Property image"/>
                                    </div>
                                }
                                </div>
                            }
                        </div>
                </mat-card-content>
            </mat-card>
        </div>
    }
    
            @if (property$ | async; as property) {
                    <!-- <div class="property-card-content">
                        
                        
                        
                        

                        
                        
                        

                        

                        

                        
                    </div> -->
            }
                @else {
                    <div class="center" style="width: 100%;">
                        <app-loader></app-loader>
                        <h3>Loading Property...</h3>
                    </div>
            }

</div>
            

